const logotext = "SV";
const meta = {
    title: "SV",
    description: "I’m SV, currently a Software Engineer at Fonterra",
};

const introdata = {
    title: "I’m SV",
    animated: {
        first: "I love problem solving.",
        second: "I'm eager to deliver results.",
        third: "I'm a tech enthusiast.",
    },
    description: "Currently a Software Engineer at Fonterra",
    your_img_url: "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
};

const dataabout = {
    title: "A bit about myself",
    aboutme: "Hello! I'm a Software Engineer at Fonterra",
};


const skills = [{
        name: "Java",
        value: 100,
    },
    {
        name: "JavaScript/TypeScript",
        value: 100,
    },
    {
        name: "Python",
        value: 100,
    },
    {
        name: "C#",
        value: 100,
    },
    {
        name: "AWS/Azure",
        value: 100,
    },
];





const contactConfig = {
    YOUR_EMAIL: "svsingh.dev@gmail.com",
    YOUR_FONE: "(+64) 22 156 6137",
    description: "Feel free to contact me by filling out the form! I'll aim to reply ASAP ",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com/sv-singh",

    linkedin: "https://linkedin.com/in/sv-dev",

};
export {
    meta,
    dataabout,

   
    skills,
  
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
